import { render } from "./projectsSlider.vue?vue&type=template&id=72d1a59e&scoped=true"
import script from "./projectsSlider.vue?vue&type=script&lang=js"
export * from "./projectsSlider.vue?vue&type=script&lang=js"

import "./projectsSlider.vue?vue&type=style&index=0&id=72d1a59e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d1a59e"]])

export default __exports__